module.exports = __webpack_public_path__ + "img/logo-title.11d277cb.png";